<template>
  <b-card>
    <footer-link-form
      v-if="footerLink"
      @onSubmit="handleSubmit"
      :footer-links="footerLinks"
      :footer-link="footerLink"
      :is-editing="true" />
  </b-card>
</template>

<script>
import FooterLinkForm from '@/components/footer-management/FooterLinkForm';
import NotificationMixin from '@/mixins/NotificationMixin';
import { all, show, update } from '@/http/footer-management';

export default {
  mixins: [NotificationMixin],

  components: {
    FooterLinkForm,
  },

  data() {
    return {
      footerLinks: [],
      footerLink: null,
    };
  },

  async created() {
    await this.fetchData();
  },

  methods: {
    async fetchData() {
      await Promise.all([this.fetchFooterLinks(), this.fetchFooterLink()]);
    },

    async fetchFooterLinks() {
      try {
        const { data } = await all();
        this.footerLinks = data.data;
      } catch (error) {
        this.showErrorNotification(
          'Problem z pobraniem danych',
          'Wystąpił problem z pobraniem linków stopki. Skontaktuj się ze swoim developerem.',
        );
      }
    },

    async fetchFooterLink() {
      try {
        const { data } = await show(this.$route.params.id);
        this.footerLink = data.data;
      } catch (error) {
        this.showErrorNotification(
          'Problem z pobraniem danych',
          'Wystąpił problem z pobraniem linku stopki. Skontaktuj się ze swoim developerem.',
        );
      }
    },

    async handleSubmit(formData) {
      try {
        await update(this.$route.params.id, formData);
        this.showSuccessNotification('Dane zostały zapisane', 'Link stopki został zaktualizowany.');
        this.$router.push({ name: 'footer-management-index' });
      } catch (error) {
        const message =
          error.response?.data?.message ??
          'Wystąpił problem z edycją linku stopki. Skontaktuj się ze swoim developerem.';
        this.showErrorNotification('Problem z zapisaniem danych', message);
      }
    },
  },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
